import { createAsyncThunk, createSlice,combineReducers } from "@reduxjs/toolkit";
import { BASE_URL } from "../config";
import { RootState } from "./store";


interface ParsedData {
  accessToken?: string;
}

interface PaymentState {
  loading: boolean;
  user: any | null;
  error: string | null;
  isLoggedIn: boolean;
  clientSecret: string | null;
}

const initialState: PaymentState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  clientSecret: null,
};

export const createPaymentIntent = createAsyncThunk(
  "payments/createPaymentIntent",
  async (programId: any, thunkAPI) => {
    try {
      const responseData = localStorage.getItem("loginData");

      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

      const response = await fetch(`${BASE_URL}/api/v1/payment/book-now`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          // Add other headers if needed
        },
        body: JSON.stringify({ programId: programId }),
      });

      

      if (!response.ok) {
        return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      
      return result;
    } catch (error: any) {
      console.error("Error fetching payment intent:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

export const createPaymentFree = createAsyncThunk(
  "payments/createPaymentFree",
  async (programId: any, thunkAPI) => {
    console.log(programId);
    try {
      const responseData = localStorage.getItem("loginData");
      
      if (!responseData) {
        console.error("Response data is null.");
        return thunkAPI.rejectWithValue("Response data is null.");
      }

      const parsedData: ParsedData = JSON.parse(responseData);
      const accessToken = parsedData?.accessToken;

      if (!accessToken) {
        console.error("Access token not found in the response.");
        return thunkAPI.rejectWithValue("Access token not found in the response.");
      }

      const response = await fetch(`${BASE_URL}/api/v1/patients/userBookingDetails/book-free`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          // Add other headers if needed
        },
        body: JSON.stringify({ programId: programId.programId }),
      });

      

      if (!response.ok) {
        return thunkAPI.rejectWithValue(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      
      return result;
    } catch (error: any) {
      console.error("Error fetching payment intent:", error.message);
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  }
);

// ./store/paymentSlice.ts
export const selectClientSecret = (state: RootState) => state.payments.clientSecret;

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentIntent.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(createPaymentIntent.fulfilled, (state, action) => {
        state.loading = false;
        // Update based on your API response structure
        state.clientSecret = action.payload.data.clientSecret; // Check the correct path
      })
      .addCase(createPaymentIntent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      })
      .addCase(createPaymentFree.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(createPaymentFree.fulfilled, (state, action) => {
        state.loading = false;
        // Update based on your API response structure
        state.clientSecret = action.payload.data; // Check the correct path
      })
      .addCase(createPaymentFree.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      });
      
  },
});
  
export const { resetState } = paymentSlice.actions;
export default paymentSlice.reducer;
